/* eslint-disable react/prop-types */
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import NewsletterForm from 'common/newsletter/newsletter-form'

const InvieToSuscribeStyled = styled.section`
  padding: 64px 0;
  color: var(--white);
  background-image: ${({ gradientMobile }) => gradientMobile || 'var(--secondaryGradient)'};
  text-align: center;
  h3 {
    max-width: 600px;
  }
  .subtitle  {
    margin: 24px auto;
    max-width: 350px;
  }
  @media(min-width: 768px) {
    .subtitle {
      margin: 32px auto;
    }
  }
  @media(min-width: 1024px) {
    background-image: ${({ gradientDesktop }) => gradientDesktop || 'var(--secondaryGradient)'};
  }
`

function NewsletterGradient({
  sendinblueConfig,
  title,
  subtitle,
  formName,
  gradientDesktop,
  gradientMobile,
  urlForm,
}) {
  return (
    <InvieToSuscribeStyled gradientDesktop={gradientDesktop} gradientMobile={gradientMobile} id="newsletter" aria-labelledby="newsletter-title">
      <Wrapper maxWidth={632}>
        <Typography as="h3" small="headline6" large="headline4" id="newsletter-title">
          {title}
        </Typography>
        <div className="subtitle">
          <Typography>
            {subtitle}
          </Typography>
        </div>
        <NewsletterForm
          formName={formName}
          btnFullWidth
          simpleForm
          authomatic
          lightForm
          automatic
          urlForm={urlForm}
        />
      </Wrapper>
    </InvieToSuscribeStyled>
  )
}

NewsletterGradient.defaultProps = {
  title: 'Construye estos increíbles proyectos con las mentorías en vivo',
  subtitle: 'Sé el primero en enterarte de todo.',
}

NewsletterGradient.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  formName: PropTypes.string.isRequired,
  urlForm: PropTypes.string.isRequired,
}

export default NewsletterGradient
